import React, { useRef } from "react";
import styled from "styled-components";

const Grid = styled.div`
  position: relative;
  display: flex;

  overflow-x: auto;
  cursor: grab;
  gap: 20px;

  @media (min-width: 765px) {
    display: grid;
    gap: 8px;
    grid-template-columns: repeat(5, 1fr);
    overflow-x: unset;
    //scroll-snap-type: none;
    cursor: default;
  }
`;

const ScrollableGrid = ({ children }) => {
  const gridRef = useRef(null);

  const handleMouseDown = (event) => {
    const grid = gridRef.current;
    grid.isDragging = true;
    grid.startX = event.pageX - grid.offsetLeft;
    grid.scrollLeftStart = grid.scrollLeft;
  };

  const handleMouseMove = (event) => {
    const grid = gridRef.current;
    if (!grid.isDragging) return;
    const x = event.pageX - grid.offsetLeft;
    const walk = (x - grid.startX) * 1.5; // Adjust scrolling speed
    grid.scrollLeft = grid.scrollLeftStart - walk;
  };

  const handleMouseUp = () => {
    const grid = gridRef.current;
    grid.isDragging = false;
  };

  return (
    <Grid
      ref={gridRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseUp}
      onMouseUp={handleMouseUp}
      data-scrollable="true"
    >
      {children}
    </Grid>
  );
};

export default ScrollableGrid;
